<template>
    <rkm-row>
        <rkm-col cols="2">
            <rkm-form-input
                label="Número"
                v-model="model.documentos.carteiraNacionalHabilitacao.numero"
                :validations="validations.numero"
                number
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-date-picker
                :validations="validations.dataEmissao"
                label="Data de emissão"
                v-model="model.documentos.carteiraNacionalHabilitacao.dataEmissao"
                :disabled="!model.documentos.carteiraNacionalHabilitacao.numero"
                :min-date="getDataNascimentoString()"
                :max-date="dataAtual"
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-date-picker
                :validations="validations.dataValidade"
                label="Data de validade"
                :disabled="!model.documentos.carteiraNacionalHabilitacao.dataEmissao"
                v-model="model.documentos.carteiraNacionalHabilitacao.dataValidade"
                :min-date="getDataEmissaoString()"
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-select
                :options="form.estados"
                :validations="validations.estado"
                label="UF"
                text-field="uf"
                v-model="model.documentos.carteiraNacionalHabilitacao.estadoId"
                :disabled="!model.documentos.carteiraNacionalHabilitacao.numero"
                value-field="id"
                show-default-option
            />
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-select
                :options="form.categorias"
                :validations="validations.categoria"
                label="Categoria"
                text-field="letra"
                v-model="model.documentos.carteiraNacionalHabilitacao.categoriaId"
                :disabled="!model.documentos.carteiraNacionalHabilitacao.numero"
                value-field="id"
                show-default-option
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
// Moment.
import moment from 'moment'

export default {
    props: {
        dataAtual: { type: String, required: true },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                numero: { min: 11, max: 11 },
                dataEmissao: { required: !!this.model.documentos.carteiraNacionalHabilitacao.numero },
                dataValidade: { required: !!this.model.documentos.carteiraNacionalHabilitacao.numero },
                estado: { required: !!this.model.documentos.carteiraNacionalHabilitacao.numero },
                categoria: { required: !!this.model.documentos.carteiraNacionalHabilitacao.numero }
            }
        }
    },
    watch: {
        'model.documentos.carteiraNacionalHabilitacao.numero': function (numero) {

            if (!numero) {

                this.model.documentos.carteiraNacionalHabilitacao.dataEmissao = null
                this.model.documentos.carteiraNacionalHabilitacao.dataValidade = null
                this.model.documentos.carteiraNacionalHabilitacao.estadoId = null
                this.model.documentos.carteiraNacionalHabilitacao.categoriaId = null
            }
        },
        'model.documentos.carteiraNacionalHabilitacao.dataEmissao': function () {

            this.model.documentos.carteiraNacionalHabilitacao.dataValidade = null
        }
    },
    methods: {
        getDataNascimentoString() {

            return this.model.dataNascimento
                ? moment(this.model.dataNascimento).format('DD/MM/YYYY')
                : null
        },
        getDataEmissaoString() {

            return this.model.documentos.carteiraNacionalHabilitacao.dataEmissao
                ? moment(this.model.documentos.carteiraNacionalHabilitacao.dataEmissao).format('DD/MM/YYYY')
                : null
        },
    },
}
</script>